// extracted by mini-css-extract-plugin
export var container = "SourcesContainer-module--container--71uiT";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var sourcesContainer = "SourcesContainer-module--sourcesContainer--eG+eg";
export var title = "SourcesContainer-module--title--cErgN";
export var titleContainer = "SourcesContainer-module--titleContainer--v4nd8";